export default __webpack_public_path__ + "static/media/digest-preview-1.d060a0e7.svg";